import { render } from "./categoriaplatillos.vue?vue&type=template&id=f6e9d546&scoped=true"
import script from "./categoriaplatillos.vue?vue&type=script&lang=js"
export * from "./categoriaplatillos.vue?vue&type=script&lang=js"

import "./categoriaplatillos.vue?vue&type=style&index=0&id=f6e9d546&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6e9d546"]])

export default __exports__